
export const highlightColorIdToHighlightColorMap: Map<string, string> = new Map<string, string>([
    ['69b9cfdb-6f1a-4631-bb51-d1d5a30ce1aa','0c0d01'],
    ['a2d86281-46c8-4a12-9cf5-f665c5e89e57','ffffff'],
    ['1a3bcf6e-e844-e911-a9db-124a916a6f54','def440'],
    ['00e23c75-e844-e911-a9db-124a916a6f54','fadc64'],
    ['01e23c75-e844-e911-a9db-124a916a6f54','99fb6b'],
    ['d003ae7e-e844-e911-a9db-124a916a6f54','6be1fb'],
    ['d103ae7e-e844-e911-a9db-124a916a6f54','ee7eeb'],
]);